import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { ModalContainer } from "../Modal/components/ModalContainer.js";
import { ModalHeader } from "../Modal/components/ModalHeader.js";
import { Modal } from "../Modal/Modal.js";
const drawer = "_drawer_gd3s3_3";
const drawerHeader = "_drawerHeader_gd3s3_24";
const drawerContainer = "_drawerContainer_gd3s3_37";
const drawerOverlayEntering = "_drawerOverlayEntering_gd3s3_46";
const drawerOverlayExiting = "_drawerOverlayExiting_gd3s3_50";
const drawerEntering = "_drawerEntering_gd3s3_55";
const drawerExiting = "_drawerExiting_gd3s3_63";
const styles = {
  drawer,
  drawerHeader,
  drawerContainer,
  drawerOverlayEntering,
  drawerOverlayExiting,
  drawerEntering,
  drawerExiting
};
const Drawer = ({
  children,
  closeButtonDescription,
  isDialog = false,
  isOpen,
  onClose,
  renderIn,
  restoreFocus = true,
  shouldMount = false,
  title,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Modal,
    {
      animationTimeout: 600,
      closeOnBlurOutside: !isDialog,
      focusTrap: isDialog,
      isOpen,
      onClose,
      renderIn,
      restoreFocus,
      shouldMount,
      title,
      transitionStyles: {
        entering: styles.drawerOverlayEntering,
        exiting: styles.drawerOverlayExiting
      },
      children: /* @__PURE__ */ jsxs(
        ModalContainer,
        {
          "aria-label": title,
          component: isDialog ? "div" : "aside",
          className: clsx(styles.drawer, props.className),
          role: isDialog ? "dialog" : void 0,
          transitionStyles: {
            entering: styles.drawerEntering,
            exiting: styles.drawerExiting
          },
          ...props,
          children: [
            /* @__PURE__ */ jsx(
              ModalHeader,
              {
                closeButtonDescription,
                className: styles.drawerHeader,
                children: title
              }
            ),
            /* @__PURE__ */ jsx("div", { className: styles.drawerContainer, children: typeof children === "string" ? /* @__PURE__ */ jsx(Text, { children }) : /* @__PURE__ */ jsx(Fragment, { children }) })
          ]
        }
      )
    }
  );
};
export {
  Drawer
};
